export default __webpack_public_path__ + "images/af463ab3a42a45feb01ac19469ccd159.svg";